import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ConfigProvider, Tabs } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Information from "./information";
import MarkerInfoHeader from "./MarkerInfoHeader";
import MarkerInfoCollapse from "./Collapse";
import MarkerInfoAbout from "./About";

function MarkerInfo({
  showModalHeader,
  pinData,
  destination,
  pinLoading = false,
}) {
  const { TabPane } = Tabs;
  const [defaultValue, setDefaultValue] = useState("3");

  useEffect(() => {
    setDefaultValue("3");
  }, [pinLoading]);

  return (
    <div className="marker-info">
      {showModalHeader && <MarkerInfoHeader data={pinData} />}
      <div className="wrapper">
        <div className="tabs">
          <ConfigProvider direction="ltr">
            <Tabs activeKey={defaultValue} centered onChange={setDefaultValue}>
              <TabPane tab={<span className="tab-icon icon-lbs-7" />} key="1">
                <ConfigProvider direction="rtl">
                  <MarkerInfoAbout
                    title={pinData.title.fields[0] || ""}
                    description={pinData.summary.fields[0] || ""}
                    loading={pinLoading}
                  />
                </ConfigProvider>
              </TabPane>
              <TabPane tab={<span className="tab-icon icon-lbs-9" />} key="2">
                <ConfigProvider direction="rtl">
                  <MarkerInfoCollapse
                    contents={pinData.content}
                    title={pinData.title.fields[0] || ""}
                    loading={pinLoading}
                  />
                </ConfigProvider>
              </TabPane>
              <TabPane
                tab={
                  <span className="tab-icon">
                    <InfoCircleOutlined />
                  </span>
                }
                key="3"
              >
                <ConfigProvider direction="rtl">
                  <Information
                    origin={origin}
                    destination={destination}
                    // location={`${pinData.lat},${pinData.lng}`}
                    informations={pinData.metaData}
                    title={pinData.title.fields[0] || ""}
                    pinData={pinData}
                    loading={pinLoading}
                  />
                </ConfigProvider>
              </TabPane>
            </Tabs>
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
}

MarkerInfo.propTypes = {
  showModalHeader: PropTypes.bool.isRequired,
};

export default MarkerInfo;
